import React, {useState} from "react";
import I18n from "i18n-js";
import PrepaidCardStateManagerButton from "./PrepaidCardStateManagerButton";
import PrepaidCardsList from "./PrepaidCardsList";
import PrepaidCardInfoButton from "./PrepaidCardInfoButton";


const PrepaidCardsSection = ({
  prepaidCards,
  userId,
  isSuperMiddleman
}) => {

  const [ prepaidCardsToRender, setPrepaidCardsToRender ] = useState(JSON.parse(prepaidCards));


  return <React.Fragment>
    {
      !prepaidCardsToRender || prepaidCardsToRender.length == 0 ?
        <div className="position-relative mb-5 pb-5">
          <div className="row">
            {
              [1,2,3,4].map((i) => {
                return (
                  <div key={i}
                    className={`col-12 col-sm-6 col-lg-4 col-xxxl-3 py-3 px-4 px-sm-3 ${i === 4 ? 'd-none d-xxxl-block' : (i === 3 ? 'd-none d-lg-block' : (i === 2 ? 'd-none d-sm-block' : ''))}`}>
                    <div className="br-20px border-aiG-light-gray-imp bg-white-gray-gradient opacity-0_3 px-0 py-4">
                      <div className="w-100 bg-white h-34px-imp"></div>

                      <div className="row p-0">
                        <div className="col-12 d-flex justify-content-end text-right align-content-center pr-4 my-3">
                          <div className="bg-white br-8px w-60px h-50px opacity-0_8"></div>
                        </div>

                        <div className="col-12 d-flex justify-content-start text-left px-0">
                          <div className="bg-white minW-100px br-20px py-2 px-1 px-sm-2 px-xl-3 ml-4"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>

          <div className="d-block justify-content-center text-center position-absolute bottom-47perc w-100">
            <p className="text-muted font-size-20px mb-4 pb-1">
              <b>{I18n.t("js.indexPrepaidCards.missingPrepaidCards")}</b>
            </p>

            <PrepaidCardStateManagerButton
              buttonText={I18n.t("js.indexPrepaidCards.activateNow").toUpperCase()}
              userId={userId}
              prepaidCards={prepaidCardsToRender}
              setPrepaidCards={setPrepaidCardsToRender}
              action={'activate'}
            />

            <PrepaidCardInfoButton
              texts={[
                I18n.t('js.indexPrepaidCards.infoModalMiddleman.text1'),
                I18n.t('js.indexPrepaidCards.infoModalMiddleman.text2'),
                I18n.t('js.indexPrepaidCards.infoModalMiddleman.text3'),
                I18n.t('js.indexPrepaidCards.infoModalMiddleman.text4')
              ]}
              type={'button'}
            />
          </div>
        </div>
    :
      <React.Fragment>
        <div className="font-size-14px">
          <PrepaidCardsList
            prepaidCards={prepaidCardsToRender.slice(0, 8)}
            prepaidCardsAnimationDivider={prepaidCardsToRender.length}
            isSuperMiddleman={isSuperMiddleman}
          />
        </div>

        <div className="row d-flex align-items-center justify-content-center text-center mb-5 pb-5">
          <a href={`/users/${userId}/prepaid_cards`} className="btn bg-aig-gradient br-50px border-none color-white mt-0 mb-1 mx-2 py-2 px-3 font-weight-bold">
            {I18n.t("js.indexPrepaidCards.seeAllCards").toUpperCase()}
          </a>

          <PrepaidCardStateManagerButton
            buttonText={I18n.t("js.indexPrepaidCards.activateNewCard").toUpperCase()}
            userId={userId}
            prepaidCards={prepaidCardsToRender}
            setPrepaidCards={setPrepaidCardsToRender}
            action={'activate'}
          />
        </div>
      </React.Fragment>
    }
  </React.Fragment>
};

export default PrepaidCardsSection;